import BaseApiClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentListApi extends BaseApiClient {
  public getDetail (id: string, varietyId: string, districtId: string) {
    const path: string = '/v1/external-link-contents'
    const url = new URL(process.env.VUE_APP_API_URL + path)
    let params: any = ''

    if (id !== '') {
      params = new URLSearchParams({
        external_link_id: id
      })
    } else if (varietyId !== '' && districtId !== '') {
      params = new URLSearchParams({
        variety_id: varietyId,
        district_id: districtId
      })
    } else if (varietyId !== '') {
      params = new URLSearchParams({
        variety_id: varietyId
      })
    } else if (districtId !== '') {
      params = new URLSearchParams({
        district_id: districtId
      })
    }

    if (params !== '') {
      url.search = params.toString()
    }

    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ExternalLinkContentListApi()
